import { Dispatch, SetStateAction } from "react";
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from "@mui/material";

import "./Filter.scss";

export interface FilterProps {
  name: string;
  state: string[];
  setState: Dispatch<SetStateAction<string[]>>;
  values: Array<{ value: string; label: string }>;
}

function Filter({ name, values, state, setState }: FilterProps) {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const {
      target: { value },
    } = event;
    setState(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <FormControl sx={{ ml: 1 }} fullWidth>
      <InputLabel>{name}</InputLabel>
      <Select
        data-cy={`${name}Filter`}
        multiple
        value={state}
        onChange={handleChange}
        input={<OutlinedInput label={name} />}
        renderValue={(selected) =>
          selected
            .map((s) => values.find((v) => v.value === s)?.label)
            .join(", ")
        }
      >
        {values.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            <Checkbox checked={state.indexOf(value) > -1} />
            <ListItemText primary={label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default Filter;
